<div class="flex-control flex-column">
  <app-tabs *ngIf="!task_user" [class.chat-container]="!tabs_service.is_active()">
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Chat</li>
  </app-tabs>
  <app-chat-listing class="flex-control flex-column" [task_user]="task_user" [hidden]="tabs_service.is_active() && !task_user"></app-chat-listing>
</div>
